let place = {
  top: {
    title_1: "Rabbit VPN服务器的",
    title_2: "位置",
    explain: "我们在世界各地拥有高性能服务器，可确保您的使用。"
  },
  download_btn: "下载 Rabbit VPN"
}
export default place


// WEBPACK FOOTER //
// ./src/assets/lang/zh/new_place/index.js